module.exports = __webpack_public_path__ + "img/logo.8a53b25a.png";